import { combineReducers } from 'redux';

// Reducers
import { AuthReducer } from './Auth';
import { UserReducer } from './User';
import { CompanyReducer } from './Company';
import { ProfileReducer } from './Profile';
import { DialogReducer } from './Dialog';
import { SnackBarReducer } from './Snackbar';
import { ProfilePermissionReducer } from './ProfilePermission';

import { VehicleReducer } from './Vehicle';

// First defining the App's state
const reducer = combineReducers({
  auth: AuthReducer,
  user: UserReducer,
  profile: ProfileReducer,
  snackbar: SnackBarReducer,
  dialog: DialogReducer,
  company: CompanyReducer,
  profilepermission: ProfilePermissionReducer,
  vehicle: VehicleReducer,
});

// An action creator which intercept the action. Case action.type = LOGOUT return the initialState (resets the state)
const root = (state, action) => {
  if (action.type === 'LOGOUT') {
    state = undefined;
    localStorage.removeItem('token');
  }

  return reducer(state, action);
};

export default root;
